//import axios from 'axios'
import { apiInstance } from '../config/apiInstance'

const REGION_BASED_URI = {
  in: window.uriIN,
  eu: window.uriEU,
  us: window.uriUS,
  croma: window.uriCroma,
}

export const getRequestAsync = async (apiEndPoint, headers) => {
  try {
    const selectedRegion = localStorage.getItem('selectedRegion')
    const response = await apiInstance.get(
      REGION_BASED_URI[selectedRegion] ? `${REGION_BASED_URI[selectedRegion]}${apiEndPoint}` : apiEndPoint,
      { headers }
    )
    if (response.status === 200 && response.data.success) {
      return response.data && response.data.data
    }
    throw response.data
  } catch (e) {
    if (e.response && e.response.data) {
      const error = {
        data: {},
        msg: e.response.data.message || 'Something went wrong !',
      }
      throw error
    }
    if (!e.message) {
      e.data = {}
      e.msg = 'Something went wrong !'
      throw e
    } else {
      e.msg = e.message
    }
    throw e
  }
}

export const postRequestAsync = async (apiEndPoint, body = {}, headers) => {
  try {
    const selectedRegion = localStorage.getItem('selectedRegion')
    const response = await apiInstance.post(
      REGION_BASED_URI[selectedRegion] ? `${REGION_BASED_URI[selectedRegion]}${apiEndPoint}` : apiEndPoint,
      body,
      { headers }
    )
    if (response.status === 200 && response.data.success) {
      return response.data && response.data
    }
    throw response.data
  } catch (e) {
    if (e.response && e.response.data) {
      const error = {
        data: {},
        msg: e.response.data.message || 'Something went wrong !',
      }
      throw error
    }
    if (!e.message && !e.msg) {
      e.data = {}
      e.msg = 'Something went wrong !'
      throw e
    } else {
      e.msg = e.message || e.msg
    }
    throw e
  }
}
